import React, { useState } from 'react';
import { Popup } from 'react-map-gl/maplibre';
import { useTheme } from '../../contexts/ThemeContext';

/** Inline popup editor for a map annotation (new, or an existing one with Delete). */
export default function AnnotationEditor({ edit, onSave, onDelete, onCancel }) {
  const { C } = useTheme();
  if (!edit) return null;
  return (
    <Popup longitude={edit.lon} latitude={edit.lat} onClose={onCancel} closeOnClick={false} offset={12} maxWidth="260px">
      <EditorBody key={edit.id || 'new'} edit={edit} C={C} onSave={onSave} onDelete={onDelete} onCancel={onCancel} />
    </Popup>
  );
}

function EditorBody({ edit, C, onSave, onDelete, onCancel }) {
  const [text, setText] = useState(edit.text || '');
  const btn = { fontSize: 11, padding: '4px 10px', borderRadius: 6, border: `1px solid ${C.border}`, cursor: 'pointer', background: C.bg4, color: C.text0 };
  return (
    <form data-testid="annotation-editor" style={{ padding: 4, minWidth: 200 }}
      onSubmit={(e) => { e.preventDefault(); onSave(text); }}>
      <input autoFocus aria-label="Annotation text" value={text} onChange={(e) => setText(e.target.value)}
        onKeyDown={(e) => { if (e.key === 'Escape') onCancel(); e.stopPropagation(); }}
        placeholder="Annotation text"
        style={{ width: '100%', boxSizing: 'border-box', fontSize: 12, padding: '4px 6px', marginBottom: 8, borderRadius: 6, border: '1px solid #cbd5e1' }} />
      <div style={{ display: 'flex', gap: 6 }}>
        <button type="submit" style={{ ...btn, background: '#00b8de', color: '#fff', border: 'none', fontWeight: 600 }}>Save</button>
        <button type="button" onClick={onCancel} style={btn}>Cancel</button>
        {edit.id && <button type="button" onClick={onDelete} style={{ ...btn, marginLeft: 'auto', color: '#ef4444' }}>Delete</button>}
      </div>
    </form>
  );
}
